import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { ProductCategories } from "./components/productcategories";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import ProductionData from "./data/production.json";
import SmoothScroll from "smooth-scroll";
import { Helmet } from "react-helmet";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});


  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === "development") {
      setLandingPageData(JsonData); // Development data
    } else {
      setLandingPageData(ProductionData); // Production data
    }
  }, []);

  return (
    <div>
      <Helmet>
        <title>{landingPageData.Header?.title || "Glora Agro International"}</title>
        <meta
          name="description"
          content={landingPageData.Header?.description || "Glora Agro International is a leading supplier of high-quality agricultural commodities, specializing in the trade, distribution, and export of spices especially cloves. Founded in 2025, as a newly established company, we are committed to sourcing, processing, and delivering high-quality agricultural products, with a focus on building lasting relationships with our customers and partners around the world."}
        />
        <script type="application/ld+json">
          {JSON.stringify(landingPageData.Google)}
        </script>
      </Helmet>
      <Navigation />
      <Header data={landingPageData.Header} />
      {/* <Features data={landingPageData.Features} /> */}
      <ProductCategories data ={landingPageData.ProductCategories} />
      <About data={landingPageData.About} />
      {/* <Category data ={landingPageData.ProductCategories} /> */}
      {/* <Services data={landingPageData.Services} /> */}
      {/* <Gallery data={landingPageData.Gallery} /> */}
      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      {/* <Team data={landingPageData.Team} /> */}
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
